import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AuxiliaryFieldSchemaApiService,
  GetAuxiliaryDataFieldSchemaResponseInterface,
  GetMultiAuxiliaryDataFieldSchemaResponseInterface,
  UpdateAuxiliaryDataFieldSchemaRequestInterface,
} from '@vendasta/account-group';
import { ListAuxiliaryDataFieldSchemaResponseInterface } from '@vendasta/account-group/lib/_internal/interfaces/fields.interface';
import { Observable } from 'rxjs';
import {
  AbstractAuxiliaryDataSchemaService,
  FieldSchema,
  FieldSchemaIdentifier,
  UpdateFieldSchemaRequest,
  UpdateSchemaFieldMask,
} from './schema-interface';

@Injectable({
  providedIn: 'root',
})
export class AccountGroupSchemaService implements AbstractAuxiliaryDataSchemaService {
  constructor(private readonly schemaService: AuxiliaryFieldSchemaApiService) {}

  listFieldSchemas(
    partnerId: string,
    onlyArchived: boolean,
    cursor: string,
    pageSize: number,
  ): Observable<ListAuxiliaryDataFieldSchemaResponseInterface> {
    return this.schemaService.listAuxiliaryDataFieldSchema({
      partnerId: partnerId,
      pagingOptions: {
        cursor: cursor,
        pageSize: pageSize,
      },
      filters: {
        onlyArchived: onlyArchived,
      },
    });
  }

  createFieldSchema(schema: FieldSchema): Observable<HttpResponse<null>> {
    return this.schemaService.createAuxiliaryDataFieldSchema({ fieldSchema: schema });
  }

  updateFieldSchema(
    changes: UpdateFieldSchemaRequest,
    fieldMask: UpdateSchemaFieldMask,
  ): Observable<HttpResponse<null>> {
    const request: UpdateAuxiliaryDataFieldSchemaRequestInterface = {
      fieldSchema: changes,
      fieldMask: { paths: fieldMask },
    };
    return this.schemaService.updateAuxiliaryDataFieldSchema(request);
  }

  getFieldSchema(id: FieldSchemaIdentifier): Observable<GetAuxiliaryDataFieldSchemaResponseInterface> {
    return this.schemaService.getAuxiliaryDataFieldSchema({ identifier: id });
  }

  getMultiFieldSchema(ids: FieldSchemaIdentifier[]): Observable<GetMultiAuxiliaryDataFieldSchemaResponseInterface> {
    return this.schemaService.getMultiAuxiliaryDataFieldSchema({
      identifiers: ids,
    });
  }

  archiveFieldSchema(id: FieldSchemaIdentifier): Observable<HttpResponse<null>> {
    return this.schemaService.archiveAuxiliaryDataFieldSchema({ identifier: id });
  }

  unarchiveFieldSchema(id: FieldSchemaIdentifier): Observable<HttpResponse<null>> {
    return this.schemaService.unarchiveAuxiliaryDataFieldSchema({ identifier: id });
  }
}
